module.exports = __webpack_public_path__ + "res/Roboto-BlackItalic-webfont.svg?b74fa902444df9a4923c9b6c3a3d511b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BlackItalic-webfont.svg
// module id = 95
// module chunks = 0